import SubMenuAccordion from "../../../../components/AccordionSubMenu";
import IconButton from "../../../../components/IconButton";
import useAppData from "../../../../hook/useAppData";
import {
  IconCollaborator,
  IconCalendar,
  IconGestion,
  IconPeopleProjects,
  IconComputer,
  IconGear,
  IconSearch,
  IconInvoice,
  IconClock,
  IconGraph,
  IconProjects,
  IconSpreadsheet,
} from "../../../../icons";
import { ACCESS } from "../../../../module/Profile/constants";

export default function AccessRoutes({ status, accordionSide, setAccordionSide }: { status; accordionSide; setAccordionSide }) {
  const { accessIds, userId } = useAppData();

  const routineAppointment = accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_read) || accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_consolidate);
  const approvalHours = accessIds?.includes(ACCESS.APPROVAL_HOURS_read_approve);
  const bankHours = accessIds?.includes(ACCESS.HOURS_MANAGEMENT_all);

  const collaborators = accessIds?.includes(ACCESS.USERS_DATA_all);
  const history = accessIds?.includes(ACCESS.HISTORY_all);

  const clients = accessIds?.includes(ACCESS.CLIENT_all);
  const projects = accessIds?.includes(ACCESS.PROJECT_read) || accessIds?.includes(ACCESS.PROJECT_write);

  const selfRegistration = accessIds?.includes(ACCESS.USERS_SELF_REGISTRATION_read);
  const invoice = accessIds?.includes(ACCESS.SELF_INVOICE_all);
  const timesheet = accessIds?.includes(ACCESS.TIMESHEET_all);

  const immobilized = accessIds?.includes(ACCESS.IMMOBILIZED_all);
  const eletronic = accessIds?.includes(ACCESS.ELETRONICS_all);

  const settings = accessIds?.includes(ACCESS.SETTINGS_all);

  return (
    <>
      {routineAppointment && approvalHours && bankHours ? (
        <SubMenuAccordion
          text="Gestão de Horas"
          icon={IconGestion}
          status={status}
          className="subMenuHoursControl"
          accordionSide={accordionSide}
          setAccordionSide={setAccordionSide}
        >
          {routineAppointment && (
            <IconButton className="menuIconSideBar" url="/routine-appointment" hiddenArial={true} text="Consolidação de Horas" />
          )}
          {approvalHours && <IconButton className="menuIconSideBar" url="/approve-hours" hiddenArial={true} text="Aprovações" />}
          {bankHours && <IconButton className="menuIconSideBar" url="/hours-management" hiddenArial={true} text="Banco de Horas" />}
        </SubMenuAccordion>
      ) : (
        <>
          {routineAppointment && (
            <IconButton className="menuIconSideBar" url="/routine-appointment" icon={IconSearch} hiddenArial={true} text="Consolidação de Horas" />
          )}
          {approvalHours && <IconButton className="menuIconSideBar" url="/approve-hours" icon={IconInvoice} hiddenArial={true} text="Aprovações" />}
          {bankHours && <IconButton className="menuIconSideBar" url="/hours-management" icon={IconClock} hiddenArial={true} text="Banco de Horas" />}
        </>
      )}

      {collaborators && history ? (
        <SubMenuAccordion
          text="Profissionais"
          icon={IconCollaborator}
          status={status}
          className="subMenuHoursControl"
          accordionSide={accordionSide}
          setAccordionSide={setAccordionSide}
        >
          {collaborators && <IconButton className="menuIconSideBar" url="/collaborator" text="Dados Cadastrais" hiddenArial={true} />}
          {history && <IconButton className="menuIconSideBar" url="/history" text="Histórico" hiddenArial={true} />}
        </SubMenuAccordion>
      ) : (
        <>
          {collaborators && (
            <IconButton className="menuIconSideBar" url="/collaborator" icon={IconCollaborator} text="Profissionais" hiddenArial={true} />
          )}
          {history && <IconButton className="menuIconSideBar" url="/history" icon={IconGraph} text="Histórico" hiddenArial={true} />}
        </>
      )}

      {clients && projects ? (
        <SubMenuAccordion
          text="Clientes"
          icon={IconPeopleProjects}
          status={status}
          className="subMenuHoursControl subMenuClients"
          accordionSide={accordionSide}
          setAccordionSide={setAccordionSide}
        >
          {clients && <IconButton className="menuIconSideBar" url="/clients" text="Dados Cadastrais" hiddenArial={true} />}
          {projects && <IconButton className="menuIconSideBar" url="/projects" text="Projetos" hiddenArial={true} />}
        </SubMenuAccordion>
      ) : (
        <>
          <div className="subMenuClients">
            {clients && <IconButton className="menuIconSideBar" url="/clients" icon={IconPeopleProjects} text="Clientes" hiddenArial={true} />}
          </div>
          {projects && <IconButton className="menuIconSideBar" url="/projects" icon={IconProjects} text="Projetos" hiddenArial={true} />}
        </>
      )}
      {selfRegistration && <SideCollaborator userId={userId} />}

      {invoice && <IconButton icon={IconInvoice} url="/invoice" className="menuIconSideBar" text="Nota Fiscal" />}

      {timesheet && <IconButton className={"menuIconSideBar"} url="/timesheet" icon={IconCalendar} text="Time Sheet" />}

      {immobilized && eletronic ? (
        <SubMenuAccordion
          text="Gestão de Inventário"
          className={` ${!status && "inventory-gestion-side "}`}
          icon={IconComputer}
          status={status}
          accordionSide={accordionSide}
          setAccordionSide={setAccordionSide}
        >
          {immobilized && <IconButton className="menuIconSideBar" url="/immobilized-inventory" hiddenArial={true} text="Imobilizados" />}
          {eletronic && <IconButton className="menuIconSideBar" url="/eletronic-inventory" hiddenArial={true} text="Eletrônicos" />}
        </SubMenuAccordion>
      ) : (
        <>
          {immobilized && (
            <IconButton className="menuIconSideBar" url="/immobilized-inventory" icon={IconSpreadsheet} hiddenArial={true} text="Imobilizados" />
          )}
          {eletronic && (
            <IconButton className="menuIconSideBar" url="/eletronic-inventory" icon={IconComputer} hiddenArial={true} text="Eletrônicos" />
          )}
        </>
      )}

      {settings && (
        <SubMenuAccordion text="Configurações" icon={IconGear} status={status} accordionSide={accordionSide} setAccordionSide={setAccordionSide}>
          <IconButton className={`menuIconSideBar`} url="/parameters/form" text="Parametros" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/technologies" text="Tecnologias" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/jobPosition" text="Cargos" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/seniority" text="Senioridades" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/cost-center" text="Centro de Custo" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/role-in-project" text="Função no Projeto" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/corporation" text="Empresa" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/profile" text="Perfis" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/taxes" text="Impostos" hiddenArial={true} />
          <IconButton className={`menuIconSideBar`} url="/job-settings" text="Rotina" hiddenArial={true} />
        </SubMenuAccordion>
      )}
    </>
  );
}

function SideCollaborator({ userId }) {
  return (
    <>
      <IconButton className="menuIconSideBar" url={`/collaborator/form/${userId}`} icon={IconCollaborator} text="Auto Perfil" />
    </>
  );
}
